module.exports = __webpack_public_path__ + "static/media/flag_pk.69274c54.png";